<template>
  <button 
    class="custom-button" 
    @click="openLink"
    :disabled="isLoading"
  >
    <span v-if="isLoading">
      <svg class="spinner" width="16" height="16" viewBox="0 0 16 16">
        <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" 
                fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
          <animate attributeName="stroke-dasharray" dur="2s" 
                   values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
        </circle>
      </svg>
      Generating Link...
    </span>
    <span v-else>Deep Price Analysis</span>
  </button>
  
  <div v-if="error" class="error-message">
    {{ error }}
    <button @click="clearError" class="close-btn">&times;</button>
  </div>
</template>

<script>
export default {
  props: {
    plantId: {
      type: [String, Number],
      default: null
    },
    alias: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      error: null,
      bridgeDomain: 'https://ai.redxvpp.com' // Change this to your bridge domain
    }
  },
  methods: {
    async openLink() {
      // Get plant_id and alias from props or URL parameters
      let plantId = this.plantId;
      let alias = this.alias;
      
      if (!plantId || !alias) {
        // Fallback to URL parameters if props not provided
        const urlParams = new URLSearchParams(window.location.search);
        plantId = plantId || urlParams.get('plant_id');
        alias = alias || urlParams.get('alias');
      }
      
      // Check if we have required parameters
      if (!plantId || !alias) {
        this.error = 'Missing required parameters (plant_id and alias)';
        return;
      }
      
      // If token-based security is enabled, generate token first
      if (this.useTokenBasedSecurity) {
        await this.openSecureLink(plantId, alias);
      } else {
        // Direct redirect (less secure but simpler)
        if (process.env.NODE_ENV === 'production') {
          window.location.href = 'https://ai.redxvpp.com/rd/price';
        } else {
          window.location.href = 'https://dev-ai.redxvpp.com/rd/price';
        }
      }
    },
    
    async openSecureLink(plantId, alias) {
      this.isLoading = true;
      this.error = null;
      
      try {
        const response = await fetch('/api/generate-bridge-token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            plant_id: plantId,
            alias: alias
          })
        });
        
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.error || `Server error: ${response.status}`);
        }
        
        if (data.token) {
          const bridgeUrl = `${this.bridgeDomain}/bridge-link?token=${data.token}`;
          window.open(bridgeUrl, '_blank');
        } else {
          throw new Error('No token received from server');
        }
        
      } catch (error) {
        console.error('Bridge link error:', error);
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    },
    
    clearError() {
      this.error = null;
    }
  },
  
  computed: {
    useTokenBasedSecurity() {
      // Set this to true when you implement the token-based Flask backend
      // Set to false to use direct redirect (current behavior)
      return false;
    }
  }
}
</script>

<style scoped>

.custom-button {
  cursor: pointer;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: none;
  border-radius: 5px;
  font-size: 14px;
}

.custom-button:hover {
  box-shadow: 0 2px 6px rgba(60,64,67,0.25);
  background: var(--custom-color1);
  color: white;
}


.custom-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.error-message {
  margin-top: 12px;
  padding: 12px;
  border-radius: 6px;
  color: var(--text-primary);
  border: 1px solid #f5c6cb;
  background-color: #f8d7da;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  color: inherit;
}
</style>